const style = {
  page: {
    backgroundColor: '#fff',
    minHeight: '100%',
  },
};

export default style;
